module.exports = "<select ng-if=\"$ctrl.mode === 'edit'\"\n        class=\"form-control\"\n        ng-if=\"$ctrl.mode === 'edit'\"\n        ng-model=\"$ctrl.ngModel\"\n        ng-disabled=\"$ctrl.ngDisabled\"\n        ng-options=\"item for item in $ctrl.locations\">\n    <option value=\"\">Not visible</option>\n</select>\n<span ng-if=\"$ctrl.mode === 'view'\" ng-bind=\"$ctrl.ngModel || 'Not visible'\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/ui.location.picker.html
// module id = 761
// module chunks = 0